<template>
	<div ref="header" class="header_container_x">
		<div class="header">
			<div class="h_logo">
				<!-- <img src="@/assets/logo.png" alt="logo" /> -->
				<p class="headerText"></p>
			</div>
			<div class="pc_disNone">
				<p @click="show_menu">
					<img src="../assets/menu.png" width="20" height="20"/>
				</p>
			</div>
			<ul class="m_disNone h_nav">
				<li
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/">{{ home }}</router-link>
				</li>
				<li
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<!-- {{ menu_product[0].id }} -->
					<router-link to="/introduction"
						>{{ about }}</router-link
					>
				</li>
				<li
				
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/project">{{ project }}</router-link>
				</li>
				<li
					
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/media">{{ media }}</router-link>
				</li>
				<li
					
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/company">{{ jobs }}</router-link>
				</li>
				<li
					
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
				>
					<router-link to="/leaving">{{ contact }}</router-link>
				</li>
				<li
					
					@mouseover="en_select_menu"
					@mouseleave="dis_select_menu"
					@click="changeLan"
				>
				<router-link to="#">CH&nbsp;&nbsp;|&nbsp;&nbsp;EN</router-link>
				</li>
			</ul>
		</div>
		<div ref="m_header" class="m_header">
			<div class="close" @click="show_menu">
			 <span class="headerText"></span>
			</div>
			<ul>
				<li class="on">
					<router-link to="/">
						{{ home }}
					</router-link>
				</li>
				<li>
					<router-link to="/introduction"
						>{{ about }}</router-link>
				</li>
				<li>
					<router-link to="/project">{{ project }}</router-link>
				</li>
				<li>
					<router-link to="/media">{{ media }}</router-link>
					
				</li>
				<li>
					<router-link to="company">{{jobs}}</router-link>
				</li>
				<li><router-link to="/leaving">{{ contact }}</router-link></li>
				<li @click="changeLan"><router-link to="#">
					CH&nbsp;&nbsp;|&nbsp;&nbsp;EN</router-link></li>
			</ul>
		</div>
	</div>
</template>
<script>
import Axios from 'axios'
export default {
	// props:[],
	data() {
		return {
			show: false,
			tab_on: '/',
			inp_on: false,
			home:'首页',
			about:'简介',
			project:'项目',
			media:'媒体',
			jobs:'招聘',
			contact:'联系',
			i: 0,
			src: '',
			chinese:'CN',
			qqNum:'',
			phoneOne:'',
			phoneTwo:'',
		}
	},
	mounted() {
		var langeType=window.sessionStorage.getItem('chinese')
		if(langeType){
			if(langeType=='CN'){
				this.chinese='CN'
					this.home='首页'
					this.about='简介'
					this.project='项目'
					this.media='媒体'
					this.jobs='招聘'
					this.contact='联系'
			}else if(langeType=='EN'){
				this.chinese='EN'
				this.home='Home'
					this.about='Introduction'
					this.project='Projects'
					this.media='Media'
					this.jobs='Career'
					this.contact='Contact'
			}
		}else{
			this.chinese='CN'
				this.home='首页'
					this.about='简介'
					this.project='项目'
					this.media='媒体'
					this.jobs='招聘'
					this.contact='联系'
		}
		// window.sessionStorage.setItem('chinese',this.chinese)
		// this.init()
		var sessionStorageData=window.sessionStorage.getItem('ABD_DATA')
		if(sessionStorageData){
			var dataOne=JSON.parse(sessionStorageData)
			var lang=this.chinese;
			for(var i=0;i<dataOne.rows.length;i++){
					if(dataOne.rows[i].sc_key=='HOME_MENU_HOME_'+lang){
						this.home=dataOne.rows[i].sc_value
					}
					if(dataOne.rows[i].sc_key=='HOME_MENU_ABOUT_'+lang){
						this.about=dataOne.rows[i].sc_value
					}
					if(dataOne.rows[i].sc_key=='HOME_MENU_PROJECT_'+lang){
						this.project=dataOne.rows[i].sc_value
					}
					if(dataOne.rows[i].sc_key=='HOME_MENU_MEDIA_'+lang){
						this.media=dataOne.rows[i].sc_value
					}
					if(dataOne.rows[i].sc_key=='HOME_MENU_JOBS_'+lang){
						this.jobs=dataOne.rows[i].sc_value
					}
					if(dataOne.rows[i].sc_key=='HOME_MENU_CONTACT_'+lang){
						this.contact=dataOne.rows[i].sc_value
					}
				}
		}else{
			Axios({
			url:'/apiv4/getSconfigList',
			data: {},
			method: 'GET',
		}).then((res) => {
			window.sessionStorage.setItem('ABD_DATA',JSON.stringify(res.data.data))
			var lang=this.chinese;
				for(var i=0;i<res.data.data.rows.length;i++){
					if(res.data.data.rows[i].sc_key=='HOME_MENU_HOME_'+lang){
						this.home=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key=='HOME_MENU_ABOUT_'+lang){
						this.about=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key=='HOME_MENU_PROJECT_'+lang){
						this.project=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key=='HOME_MENU_MEDIA_'+lang){
						this.media=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key=='HOME_MENU_JOBS_'+lang){
						this.jobs=res.data.data.rows[i].sc_value
					}
					if(res.data.data.rows[i].sc_key=='HOME_MENU_CONTACT_'+lang){
						this.contact=res.data.data.rows[i].sc_value
					}
				}
		})
		}
	},
	methods: {
		changeLan(){
			this.$router.go(0)
			var language=window.sessionStorage.getItem('chinese')
			if(language){
				if(language=='CN'){
					this.chinese='EN'
					this.home='Home'
					this.about='Introduction'
					this.project='Projects'
					this.media='Media'
					this.jobs='Career'
					this.contact='Contact'
					window.sessionStorage.setItem('chinese',this.chinese)
				}
				if(language=='EN'){
					this.chinese='CN'
					this.home='首页'
					this.about='简介'
					this.project='项目'
					this.media='媒体'
					this.jobs='招聘'
					this.contact='联系'
					window.sessionStorage.setItem('chinese',this.chinese)
				}
			}else{
				window.sessionStorage.setItem('chinese','EN')
				this.home='Home'
				this.about='Introduction'
				this.project='Projects'
				this.media='Media'
				this.jobs='Career'
				this.contact='Contact'
			}
		},
		goAbout(){
	
		},
		goSearchList() {
		},
		show_menu() {
			this.show = !this.show
			if (this.show) {
				this.$move(
					this.$refs.m_header,
					{ height: '100' },
					{ company: 'vh', type: 'easeInStrong' }
				)
			} else {
				this.$move(this.$refs.m_header, { height: 0 }, { type: 'easeInStrong' })
			}
		},
		en_select_menu(e) {
			if (e.target.children[1]) {
				var oTarget = e.target.children[1]
				var oH = oTarget.children[0].offsetHeight * oTarget.children.length
				this.$move(oTarget, { height: oH }, { type: 'easeIn', time: 50 })
			}
		},
		dis_select_menu(e) {
			if (e.target.children[1]) {
				var oTarget = e.target.children[1]
				this.$move(oTarget, { height: 0 }, { type: 'easeIn', time: 50 })
			}
		},
		gohome() {
			this.$router.push('/')
		},
		init() {
			this.tab_on = this.$route.path
		},
		leaving() {
			this.$router.push('/leaving')
		},
		expand() {
			this.inp_on = !this.inp_on
		},
	},
}
</script>
<style lang="scss" scoped >
@media (min-width: 1200px) {
	@import '../style/base.scss';
	@import '../style/header.scss';
}
@media (max-width: 1199px) {
	@import '../style/mb.scss';
	@import '../style/m-header.scss';
}
</style>